import type { FC, JSX } from "react";

import type { track } from "./context";
import { useTrack } from "./useTrack";

export type { track };

interface IWithTrackProps {
    children(trackFn: track): JSX.Element;
}

const WithTrack: FC<IWithTrackProps> = ({ children }) => {
    const [track] = useTrack();

    return children(track);
};

export default WithTrack;
